import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  timeout: 15000,
});

export const initUser = (device_id, referrer_device_id, platform = "web") =>
  apiClient.post("/users/init", { device_id, referrer_device_id, platform }).then((r) => r.data);

export const getPremium = (device_id) =>
  apiClient.get(`/users/${device_id}/premium`).then((r) => r.data);

export const createCheckoutSession = (device_id, pkg, origin_url = window.location.origin) =>
  apiClient.post("/checkout/session", { device_id, package: pkg, origin_url }).then((r) => r.data);

export const getCheckoutStatus = (session_id) =>
  apiClient.get(`/checkout/status/${session_id}`).then((r) => r.data);

export const postEvent = (device_id, event, properties = {}) =>
  apiClient.post("/analytics/event", { device_id, event, properties }).then((r) => r.data).catch(() => null);

export const getAffiliatePreview = () =>
  apiClient.get("/affiliate/preview").then((r) => r.data);

export const requestMagicLink = (device_id, email, origin_url) =>
  apiClient.post("/auth/magic-link/request", { device_id, email, origin_url }).then((r) => r.data);

export const verifyMagicLink = (token, device_id) =>
  apiClient.post("/auth/magic-link/verify", { token, device_id }).then((r) => r.data);

export const getAccountMe = (device_id) =>
  apiClient.get(`/account/me?device_id=${encodeURIComponent(device_id)}`).then((r) => r.data);

export const unlinkAccount = (device_id) =>
  apiClient.post("/account/unlink", { device_id }).then((r) => r.data);

export const deleteAccount = (device_id) =>
  apiClient.post("/account/delete", { device_id }).then((r) => r.data);

export const getFamily = (device_id) =>
  apiClient.get(`/family?device_id=${encodeURIComponent(device_id)}`).then((r) => r.data);

export const joinFamily = (device_id, code, label) =>
  apiClient.post("/family/join", { device_id, code, label }).then((r) => r.data);

export const removeFamilyMember = (device_id, member_device_id) =>
  apiClient.post("/family/remove", { device_id, member_device_id }).then((r) => r.data);

export const leaveFamily = (device_id) =>
  apiClient.post("/family/leave", { device_id }).then((r) => r.data);

export const regenerateFamilyCode = (device_id) =>
  apiClient.post("/family/regenerate-code", { device_id }).then((r) => r.data);
